import { useNavigate } from "react-router-dom-v5-compat";
import { useI18nContext } from "@hopper-b2b/i18n";
import { SimplePageHeader } from "@hsbc/portal";
import {
  CarLocationAutocomplete,
  type CarLocationSuggestion,
  useCarSearch,
} from "@tenant/cars";
import { Page } from "@tenant/ui";

export enum CAR_SEARCH_MODE {
  PICK_UP = "pick-up",
  DROP_OFF = "drop-off",
}

export type CarSearchDialogProps = {
  mode: CAR_SEARCH_MODE;
};

export const CarSearchDialog: React.FC<CarSearchDialogProps> = ({ mode }) => {
  const { t } = useI18nContext();

  const {
    context: { pickupLocation, dropoffLocation },
    handlers: { handlePickupLocationChange, handleDropoffLocationChange },
  } = useCarSearch();

  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const onChange = (place: CarLocationSuggestion) => {
    if (mode === CAR_SEARCH_MODE.PICK_UP) {
      handlePickupLocationChange(place);
    } else {
      handleDropoffLocationChange(place);
    }

    goBack();
  };

  const label =
    mode === CAR_SEARCH_MODE.PICK_UP
      ? t("core-cars.search.pickup")
      : t("core-cars.search.dropoff");

  return (
    <Page header={<SimplePageHeader title={label} onBack={goBack} />}>
      <CarLocationAutocomplete
        label={label}
        value={
          (mode === CAR_SEARCH_MODE.PICK_UP
            ? pickupLocation
            : dropoffLocation) as CarLocationSuggestion
        }
        onChange={onChange}
        id="pickup-location-autocomplete"
        placeholder={t("core-cars.search.searchPlaceholder")}
      />
    </Page>
  );
};
